<template>
	<ClientOnly>
		<CardGeneric class="text-left cardSpacing orderInfoComponent">
			<p class="cardTitle">{{ $t("orderSummaryTitle") }}</p>
			<p class="cardSubTitle text-ternary">{{ $t("orderSummarySubtitle") }}</p>

			<CheckoutOrderSummaryCurrencyRow />

			<div v-if="items.size">
				<CheckoutLineItem
					v-for="item in displayItems"
					:key="item.id + item.price + item.quantity"
					:id="item.id"
					:title="item.title"
					:price="item.price"
					:imageSrc="item.images ? item.images[0] : runtimeConfig.public.DEFAULT_PRODUCT_IMAGE"
					:quantity="item.quantity"
					:is-removable="item.isRemovable"
					:is-reservation-enabled="!!item.reservationSection"
					class="mb-4 last:mb-0" />
			</div>
			<div
				v-else
				class="text-ternary text-xs text-center mb-4">
				{{ $t("emptyCart") }}
			</div>

			<CardDivider color="border-ternary" />

			<CheckoutPriceBreakdown />

			<CardDivider color="border-ternary" />

			<CheckoutTotal />
		</CardGeneric>
	</ClientOnly>
</template>

<script setup>
	import { useCartStore } from "~/stores/CartStore"
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"

	const runtimeConfig = useRuntimeConfig()
	const cartStore = useCartStore()
	const { items } = storeToRefs(cartStore)
	const displayItems = ref(cartStore.getItems())
	watch(items, () => {
		displayItems.value = cartStore.getItems()
	})

	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)
</script>

<style scoped></style>
